<template>
  <div :class="name">
    <SitecoreComponent
      v-for="component in components"
      :key="component.uid"
      :component="component"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  name: { type: String, required: true },
  rendering: { type: Object, required: false },
});

const components = computed(() => props.rendering?.placeholders?.[props.name]);
</script>
